import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateDistributionSubcategoryByIdMutation, MutateDistributionSubcategoryByIdMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { distributionSubcategoryCreatedUpdatedByIdDocument } from '../useDistributionSubcategoryCreatedUpdatedById'

const document = graphql(/* graphql */`
  mutation mutateDistributionSubcategoryById($id: MongoID!, $record: UpdateByIdDistribution_SubcategoryInput!) {
    cat {
      distributionSubcategory {
        updateById(_id: $id, record: $record) {
          recordId
        }
      }
    }
  }
`)

export type UseMutateDistributionSubcategoryByIdReturn = UseMutationResult<
MutateDistributionSubcategoryByIdMutation,
unknown,
MutateDistributionSubcategoryByIdMutationVariables
>

const useMutateDistributionSubcategoryById = (): UseMutateDistributionSubcategoryByIdReturn => {
  const invalidateCreatedUpdated = useInvalidateQueryByDocument(distributionSubcategoryCreatedUpdatedByIdDocument)
  return useGraphMutation(document, {
    onSuccess: (data) => {
      const id = data.cat?.distributionSubcategory?.updateById?.recordId
      if (typeof id === 'string') {
        void invalidateCreatedUpdated({ id })
      }
    }
  })
}

export { useMutateDistributionSubcategoryById, document as mutateDistributionSubcategoryByIdDocument }
